import { Component, OnInit, ViewChild } from '@angular/core';
import { Log } from '@src/app/models/log';
import { AdminService } from './service/admin.service';
import { Columns, API, APIDefinition, DefaultConfig, Config } from 'ngx-easy-table';
import { UniqueLogUsersPerDate } from './model/UniqueLogUsersPerDate';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.css']
})
export class AdminComponent implements OnInit {
  @ViewChild('table') table: APIDefinition;
  logs:Log[];
  public configuration: Config;
  public columns: Columns[];
  uniqueUsers: UniqueLogUsersPerDate;

  constructor(private as:AdminService) { }

  ngOnInit(): void {
    //console.log('Admin page initialized');
    var from = new Date();
    from.setDate(from.getDate() -1);
    var to = new Date();
    this.as.getLogs(from.toISOString(),to.toISOString()).pipe(untilDestroyed(this)).subscribe(data=>{
      this.logs = data;
      //sort the logs by time newest first
      this.logs.sort((a,b) => (a.timeISO > b.timeISO) ? - 1 : 1);
      //console.log('Logs Data', data);
      for (var log of this.logs){
        if(sessionStorage.getItem('person_'+log.loguser)){
          log.loguser = JSON.parse(sessionStorage.getItem('person_'+ log.loguser)).fullname;
        
        }else{
        this.as.getPerson(log.loguser).pipe(untilDestroyed(this)).subscribe(person =>{
          sessionStorage.setItem('person_'+log.loguser,JSON.stringify(person));
          log.loguser = person.fullname;
        });
      }
      }
      const uniqueLogs = this.countUniqueLogUsersPerDate(this.logs);
     // //console.log('Unique LogIns Per date: ',uniqueLogs);
    });
    this.configuration = { ...DefaultConfig };
    this.configuration.searchEnabled = false;
    this.configuration.paginationEnabled = true;
    this.configuration.orderEnabled = true;
    // ... etc.
    this.columns = [
      { key: 'logtype', title: 'Log type' },
      { key: 'timeISO', title: 'Age' },
      { key: 'loguser', title: 'User' },
      { key: 'message', title: 'Message' },
      { key: 'logurl', title: 'URL' },
    ];
  }

  //getLogRange(var days) {

//  }

  countUniqueLogUsersPerDate(logs: Log[]): UniqueLogUsersPerDate[] {
  const uniqueLogUsersPerDate: UniqueLogUsersPerDate[] = [];
  const logUsersPerDate = new Map<string, Set<string>>(); // Map of date to Set of unique log users

  // Iterate through the logs and group log users by date
  for (const log of logs) {
    const date = log.timeISO.substring(0, 10);
    if (!logUsersPerDate.has(date)) {
      logUsersPerDate.set(date, new Set<string>());
    }
    logUsersPerDate.get(date)?.add(log.loguser);
  }

  // Iterate through the grouped log users and count the number of unique users per date
  for (const [dates, users] of logUsersPerDate) {
    uniqueLogUsersPerDate.push({
      date: parseInt(dates),
      value: users.size,
    });
  }

  return uniqueLogUsersPerDate;
}
 
  onChange(event: Event): void {
    this.table.apiEvent({
      type: API.onGlobalSearch,
      value: (event.target as HTMLInputElement).value,
    });
  }
  }


